import { any } from 'prop-types';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';

export const fetchDSConfig = (dealerUserData: any, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchDSConfigAction => {
  return {
    type: actionsTypes.FETCH_DSCONFIG,
    dealerUserData,
    callback
  };
};

export const setDSConfig = (dsconfig: actionsInterfaces.IDSConfig): actionsInterfaces.ISetDSConfigAction => {
  return {
    type: actionsTypes.SET_DSCONFIG,
    dsconfig,
  };
};

export const addBrand = (brandDefinition: actionsInterfaces.IBrandDefinition): actionsInterfaces.IAddBrand => {
  return {
    type: actionsTypes.ADD_BRAND,
    brandDefinition
  }
}

export const removeBrand = (id: string): actionsInterfaces.IRemoveBrand => {
  return {
    type: actionsTypes.REMOVE_BRAND,
    id
  }
}

export const addOEMColor = (oem: string, color: string, modifyLastColor: boolean, dealerUserData: any, callback?: (result: any, error: any) => void): actionsInterfaces.ISetOEMColor => {
  return {
    type: actionsTypes.ADD_OEM_COLOR,
    oem,
    color,
    modifyLastColor,
    dealerUserData,
    callback
  };
};